// Add your API invoke URL below, configured in Module 3. 

module.exports = {
    api: {
        invokeUrl: 'https://bee60inn8c.execute-api.us-east-1.amazonaws.com/prod' 
    }
}
